var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "126", height: "112", viewBox: "0 0 126 112", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { className: styles["st0"] || "st0", d: "M62.274 8.22c-.5-.5-1.1-.7-1.7-.7h-46.7c-5.3 0-9.7 4.2-9.7 9.5v73.9c-.1 5.3 4.2 9.6 9.5 9.7h58.5c5.3 0 9.6-4.2 9.7-9.5v-62.8c0-.6-.3-1.2-.7-1.7l-18.9-18.4zm15.7 82.6c.1 3.1-2.3 5.7-5.4 5.8h-58.7c-3.1.1-5.7-2.3-5.8-5.5v-74c-.2-3 2.3-5.6 5.4-5.7h45.3c.6 0 1.3.3 1.7.7l16.8 16.3c.5.4.7 1.1.7 1.7v60.7z", style: {
        transformOrigin: "43.0231px 54.07px"
      }, fill: "#eb6608" }),
    React.createElement("path", { className: styles["st0"] || "st0", d: "M64.774 80.62h-45.7c-1.4.1-2.5 1.1-2.3 2.2.2.9 1.1 1.6 2.3 1.7h45.8c1.5-.1 2.5-1.1 2.3-2.2-.2-.9-1.1-1.6-2.4-1.7z", style: {
        transformOrigin: "41.9749px 82.57px"
      }, fill: "#eb6608" }),
    React.createElement("path", { className: styles["st0"] || "st0", d: "M64.774 64.72h-45.7c-1.4.1-2.5 1.1-2.3 2.2.2.9 1.1 1.6 2.3 1.7h45.8c1.5-.1 2.5-1.1 2.3-2.2-.2-.9-1.1-1.6-2.4-1.7z", style: {
        transformOrigin: "41.9749px 66.67px"
      }, fill: "#eb6608" }),
    React.createElement("path", { className: styles["st0"] || "st0", d: "M64.774 48.82h-45.7c-1.4.1-2.5 1.1-2.3 2.2.2.9 1.1 1.6 2.3 1.7h45.8c1.5-.1 2.5-1.1 2.3-2.2-.2-.9-1.1-1.6-2.4-1.7z", style: {
        transformOrigin: "41.9749px 50.77px"
      }, fill: "#eb6608" }),
    React.createElement("path", { className: styles["st0"] || "st0", d: "M81.574 33.72c0 1-.8 1.9-1.9 1.9h-17.8c-4.2 0-7.7-3.5-7.7-7.7V9.82c0-1 .8-1.9 1.9-1.9 1 0 1.9.8 1.9 1.9v17c0 2.8 2.3 5.1 5.1 5.1h16.7c.9-.1 1.8.8 1.8 1.8z", style: {
        transformOrigin: "67.874px 21.77px"
      }, fill: "#eb6608" })
  );
});